import { Component, ChangeDetectorRef, OnInit, HostListener, ViewChild } from '@angular/core';
import { CompanyDetailsService } from '../services/company-details.service';
import { UserService } from '../services/user.service';
import { NotificationsService } from '../services/notifications.service';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { LoaderService } from '../services/loader.service';
import { forkJoin } from 'rxjs';
import ITEMS from '../sidenav-items';
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})

export class SidenavComponent implements OnInit {
  public company;
  public items = ITEMS;
  public smallScreen;
  public sn;
  public tb;
  public toolbar;
  public flag;
  public content;
  public sidenavWidth = 230;
  public passportChanged = false;
  public notification_count;
  public loading = false;
  public system;
  public student;
  public programArr = [];
  public current_program = "";

  topCards = {
    // student_id: { label: "Student ID", color: "#607D8B", icon: "account_box", value: "", tert: false },
    // matric_no: { label: "Matric Number", color: "#607D8B", icon: "account_box", value: "", tert: true },
    level_semester: { label: "Level | Semester", color: "#2196F3", icon: "school", value: "", tert: true, psec: false },
    class: { label: "Class", color: "#2196F3", icon: "school", value: "", tert: false, psec: true },
    // cgpa: { label: "Current CGPA", color: "#E91E63", icon: "insights", value: "", tert: true, psec: false },
    current_term: { label: "Current Term", color: "#E91E63", icon: "insights", value: "", tert: false, psec: true },
    current_session: { label: "Current Session", color: "#3F51B5", icon: "insights", value: "", tert: true, psec: true },
    dept_programme: { label: "Dept | Programme", color: "#3F51B5", icon: "category", value: "", tert: true, psec: false },
  }

  getCards () {
    return Object.values(this.topCards)
      .filter((data) => this.system == 'tert' ? data.tert : data.psec)
      .map((data) => data)
  }

  constructor (private _companyDetailsService: CompanyDetailsService,
    private _userService: UserService, private _notificationsService: NotificationsService,
    private swPush: SwPush, private _loaderService: LoaderService,
    private changeDetector: ChangeDetectorRef) {
    this.showMessages();
  }

  ngOnInit () {
    this.system = localStorage.getItem('p_system');
    this._companyDetailsService.getDetails().subscribe(data => {
      this.company = data;
    })

    // forkJoin([
    this._userService.getUserData().subscribe(data => {
      this.student = data;
      let semester = ''
      if (data.semester_alias == "0") {
        semester = "";
      } else {
        semester = data.semester_alias;
      }

      // this.topCards.matric_no.value = data.matric_no;
      this.topCards.current_session.value = data.session_year;
      this.topCards.current_term.value = data.term;
      // this.topCards.student_id.value = data.student_id;
      this.topCards.class.value = `${data.name} ${data.tag}`;
      this.topCards.level_semester.value = `${data.tag} | ${semester}`;
      this.topCards.dept_programme.value = `${data.category} | ${data.name}`;
    });

    this._userService.getPrograms().subscribe(data => {
      this.programArr = data;
      let index = data.findIndex(p => p.current_program)
      this.current_program = data[index]?.name;
    })
    // ]).subscribe(([studend, programs]))

    this._loaderService.changeEmitted$.subscribe(data => {
      this.loading = data.loader;
    })

    this._userService.changeEmitted$.subscribe(data => {
      this.passportChanged = data.passportChanged;
      if (this.passportChanged) {
        this._userService.getUserData().subscribe(data => {
          this.student = data;
        })
      }
    })
    this.configureSideNav();
  }

  switchProgram (st_pr_id) {
    this._userService.switchProgram({ st_pr_id }).subscribe(data => {
      this._userService.programChange.next({ st_pr_id });
      let index = this.programArr.findIndex(p => p.st_pr_id == st_pr_id);
      this.current_program = this.programArr[index].name
    })
  }

  ngAfterContentChecked (): void {
    this.changeDetector.detectChanges();
  }
  @ViewChild('sidenav', { static: true }) sidenav

  @HostListener('window:resize', ['$event'])
  onResize (event) {
    this.configureSideNav();
  }
  @HostListener('window:load', ['$event'])
  onLoad (event) {
    this.configureSideNav();
  }

  configureSideNav () {
    this.flag = true;
    this.sn = document.querySelector("#sidenav");
    this.content = document.querySelector("mat-sidenav-content");
    this.toolbar = document.querySelector("mat-toolbar");
    this.tb = document.getElementById("toolbar");
    this.sn.style.width = "230px";
    this.smallScreen = window.innerWidth < 601 ? true : false;
    if (!this.smallScreen) {
      this.sidenav.mode = "side";
      this.sidenav.opened = true;
    } else {
      this.sidenav.mode = 'over';
      this.sidenav.opened = false;
    }
  }
  closeIt () {
    if (window.innerWidth < 501) {
      this.sidenav.close()
    }
  }
  decrease () {
    this.sidenavWidth = 55;
    this.content.style.marginLeft = "55px";
    this.toolbar.style.width = "calc(100% - 1.5rem)";
    this.flag = false;
  }
  increase () {
    this.sidenavWidth = 230;
    this.content.style.marginLeft = "230px";
    this.toolbar.style.width = "calc(100% - 13rem)";
    this.flag = true;
  }
  recon () {
    if (window.innerWidth >= 501) {
      if (this.flag) {
        this.decrease();
      } else {
        this.increase();
      }
      this.sidenav.opened = true;
    }
  }

  showMessages () {

    this.swPush.messages
      .subscribe((message: any) => {

        //console.log('[App sidenav] Push message received', message.notification);
        this.notification_count = message.notification.no;
        //this._notificationsService.notificationMessage(message);

      })

  }
  clearBadge () {
    this.notification_count = null;
  }


}

